import { createFileRoute } from "@tanstack/react-router"
import { TutorialPage1 } from "./-TutorialPage1"
import { TutorialPage2 } from "./-TutorialPage2"

function RouteComponent() {
  return <TutorialPage2 />
  // return <TutorialPage1 />
}

export const Route = createFileRoute("/tutorial/")({
  component: RouteComponent,
})
